import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export interface Wrapper {
  width?: number | string
  center?: boolean
  kind?: string
  mobileWraps?: boolean
  wrap?: boolean
  verticalCenter?: boolean
}

const getVisualization = (kind: string) => {
  switch (kind) {
    case 'between':
      return 'justify-content: space-between;'
    case 'around':
      return 'justify-content: space-around;'
    default:
      return ''
  }
}

export const FlexWrapper = styled.div`
  display: flex;
  ${(props: Wrapper) => props.center ? `
    justify-content: center;
  ` : ''}
  ${(props: Wrapper) => props.verticalCenter ? `
    align-items: center;
  ` : ''}

  ${(props: Wrapper) => bp('lg')`
    display: ${props.mobileWraps ? 'block' : 'flex'}
  `}
  ${(props: Wrapper) => props.kind ? getVisualization(props.kind) : ''}
  ${(props: Wrapper) => props.width ? `
    width: ${props.width};
    
    > * {
      flex-grow: 1;
    }
  ` : ''}
  ${(props: Wrapper) => props.wrap ? `
    flex-wrap: wrap;
  ` : ''}
`

export const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
